import type { ReactNode } from 'react';

import { NumberInput } from 'cpool-components/input/NumberInput';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { FormField } from './FormField';

type FormNumberInputProps<TFieldValues extends FieldValues> = {
    allowDecimals?: boolean;
    ariaLabel?: string;
    control: Control<TFieldValues>;
    disabled?: boolean;
    id: Path<TFieldValues>;
    label: string;
    labelClassName?: string;
    max?: number;
    measuringUnit?: ReactNode;
    min?: number;
    onValueChange?: (value: number | null) => void;
    placeholder?: string;
};

export const FormNumberInput = <TFieldValues extends FieldValues>({
    allowDecimals,
    ariaLabel,
    control,
    disabled,
    id,
    label,
    labelClassName = 'h-8 w-[175px] shrink-0 justify-start',
    max,
    measuringUnit,
    min,
    onValueChange,
    placeholder,
}: FormNumberInputProps<TFieldValues>) => (
    <FormField<TFieldValues, number | null> control={control} name={id}>
        {({ error, onChange, value }) => (
            <NumberInput
                aria-label={ariaLabel}
                id={id}
                label={label}
                value={value}
                onChange={(newValue) => {
                    onChange(newValue);
                    onValueChange?.(newValue);
                }}
                min={min}
                max={max}
                measuringUnit={measuringUnit}
                placeholder={placeholder}
                allowDecimals={allowDecimals}
                disabled={disabled}
                labelClassName={labelClassName}
                className="w-full"
                error={error}
            />
        )}
    </FormField>
);
